import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { EMPTY } from 'rxjs';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';

import { AccountBackend } from '@libs/src/account/account.backend';
import { DestroySubscriptionsService } from '@libs/src/destroy-subscription/destroy-subscription.service';
import { ToastService } from '@libs/src/toast/toast.service';
import { ZendeskService } from '@libs/src/zendesk/zendesk.service';

import { getServerError } from '@libs/src/error-handler/error-handler.helper';
import { Account } from '@libs/src/models/account.model';
import { SetUser } from '@libs/src/user/user.actions';
import { IAppState } from '@main-client/src/app/app.state';
import { isTenThousandCoffeesAdmin } from '@main-client/src/app/user/user.helpers';

@Component({
  providers: [DestroySubscriptionsService],
  selector: 'app-settings-screen-recording',
  templateUrl: './settings-screen-recording.component.html',
})
export class SettingsScreenRecordingComponent implements OnInit {
  @Input({ required: true }) user: Account;
  optedIntoScreenRecording = false;
  isLoading = false;
  isTenThousandCoffeesAdmin = false;

  constructor(
    private readonly accountBackend: AccountBackend,
    private readonly destroy$: DestroySubscriptionsService,
    private readonly store: Store<IAppState>,
    private readonly toastService: ToastService,
    private readonly zendeskService: ZendeskService,
  ) {}

  ngOnInit() {
    this.isTenThousandCoffeesAdmin = isTenThousandCoffeesAdmin(this.user);
    this.optedIntoScreenRecording = this.isTenThousandCoffeesAdmin
      ? true
      : (this.user?.opted_for_screen_recording ?? false);
  }

  saveChange(updatedValue: boolean) {
    this.isLoading = true;
    this.accountBackend
      .patchAccount({ opted_for_screen_recording: updatedValue })
      .pipe(
        tap(({ data: updatedAccount }) => {
          this.store.dispatch(
            SetUser({
              ...this.user,
              opted_for_screen_recording:
                updatedAccount.opted_for_screen_recording,
            }),
          );
          this.toastService.showSuccess(
            $localize`:@@settingsScreenRecording.changeSuccess:Changes saved! Please refresh your browser for changes to take effect.`,
          );
        }),
        catchError((error: HttpErrorResponse) => {
          this.toastService.showError(getServerError(error));
          return EMPTY;
        }),
        finalize(() => {
          this.isLoading = false;
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  showZendesk() {
    this.zendeskService.showZendesk();
  }
}
